import { render } from "./ManagePeopleUserProfile.vue?vue&type=template&id=15f857d1&lang=pug"
import script from "./ManagePeopleUserProfile.vue?vue&type=script&lang=js"
export * from "./ManagePeopleUserProfile.vue?vue&type=script&lang=js"

import "./ManagePeopleUserProfile.vue?vue&type=style&index=0&id=15f857d1&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__